import { render, staticRenderFns } from "./v2.vue?vue&type=template&id=847c6252&scoped=true&"
import script from "./v2.vue?vue&type=script&lang=js&"
export * from "./v2.vue?vue&type=script&lang=js&"
import style0 from "./v2.vue?vue&type=style&index=0&id=847c6252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847c6252",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('847c6252')) {
      api.createRecord('847c6252', component.options)
    } else {
      api.reload('847c6252', component.options)
    }
    module.hot.accept("./v2.vue?vue&type=template&id=847c6252&scoped=true&", function () {
      api.rerender('847c6252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/merchant-dashboard/v2.vue"
export default component.exports